<template>
  <div class="app">
    <router-view />
    <div class="global-nav">
      
      <router-link class="nav-item" to="/"><i class="fas fa-box-open"></i><span>首页</span></router-link>
      <router-link class="nav-item" to="/bill"><i class="fas fa-qrcode"></i><span>细胞</span></router-link>
      <router-link class="nav-item" to="/mine"><i class="fas fa-user"></i><span>我的</span></router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html, body, #app, .app { height: 100%; margin: 0; background: #f6f6f6; }
.global-nav {
  position: fixed;
  left: 0; right: 0; bottom: 0;
  height: 56px;
  background: #fff;
  border-top: 1px solid #eee;
  display: flex;
  align-items: center;
  justify-content: space-around;
  z-index: 10;
}
.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
  color: #666;
  text-decoration: none;
}
.nav-item i { font-size: 18px; margin-bottom: 2px; }
.router-link-exact-active { color: #3498db; }
</style>
